import { appParams, BaseAdapter, normalizeCollectionResponse, normalizeRecordResponse } from 'api';
import { formatAuthHeaders } from 'utils';

export type ssrQuery = Promise<{ data: any; meta?: any }>;

// Computed
export const client = new BaseAdapter({ domain: process.env.NEXT_PUBLIC_API_DOMAIN });

export const computeHeaders = req => {
	return formatAuthHeaders(req.cookies, { titleCase: false });
};

export const agentToolsQuery = async ({ req }) => {
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: '/agent-tools', headers });
	return normalizeCollectionResponse(response);
};

export const browseQuery = async ({ req, params }) => {
	const formattedParams = { ...appParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/browse`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const featuredQuery = async ({ req, params }) => {
	const formattedParams = { ...appParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/featured`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const popularQuery = async ({ req, params }) => {
	const formattedParams = { ...appParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/popular`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const recentQuery = async ({ req, params }) => {
	const formattedParams = { ...appParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/recent`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const taxonomyQuery = async ({ req, params }) => {
	const formattedParams = { ...appParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/taxonomy`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};

export const trendingQuery = async ({ req, params }) => {
	const formattedParams = { ...appParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/trending`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};
